<template>
  <a-layout id="main-layout">
    <a-layout-sider
      breakpoint="lg"
      collapsedWidth="0"
      @collapse="onCollapse"
    >
      <div class="logo">
        <img src=".././assets/logo.png" style="max-height: 100%; max-width: 100%">
      </div>
      <a-menu theme="dark" mode="inline" :defaultSelectedKeys="[1]" v-on:select="onSelect" v-model="navKey">
        <a-menu-item
          v-for="nav in navList"
          :key="nav.key"
        >
          <router-link v-bind:to="nav.value"></router-link>
          <a-icon :type="nav.iconType" />
          <span class="nav-text">{{ nav.name }}</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="display: flex; justify-content: flex-end; align-items: center; background: #fff; padding: 0;">
        <a-avatar size="large" icon="user" style="margin-right: 10px"/>
        <a @click="logout" style="height: 100%">
          <a-avatar size="large" icon="logout" :style="{ backgroundColor: '#fff', color: 'rgba(0, 0, 0, 0.65)', marginRight: '10px', marginTop: '12px' }"/>
        </a>
      </a-layout-header>
      <a-layout-content :style="{ margin: '24px 16px 0' }">
        <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
          <router-view></router-view>
        </div>
      </a-layout-content>
      <a-layout-footer style="textAlign: center">
        Zidou Union ©2018 Created by DOODOD
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>

<script>
import '../config/global'
import DeviceManage from './DeviceManage'

const axios = require('axios')
export default {
  name: 'MainLayout',
  components: {DeviceManage},
  created () {
    this.fetch()
  },
  data () {
    return {
      navKey: [],
      navList: [],
      getUserUrlPermissionUrlPostFix: 'ULogin/get_user_permission_list'
    }
  },
  computed: {
    getUserUrlPermissionUrl: function () {
      return global.DOMAIN + global.API_VERSION + this.getUserUrlPermissionUrlPostFix
    }
  },
  mounted(){
    this.$nextTick(()=>{
      document.getElementById('main-layout') && document.getElementById('main-layout').setAttribute('style', `min-height: ${document.body.clientHeight}px`)
    })
    
  },
  methods: {
    onCollapse (collapsed, type) {
      // console.log(collapsed, type)
    },

    logout () {
      sessionStorage.token = ''
      this.$router.push('/')
    },

    onSelect (obj) {
      // console.log('onSelect', obj, this.navKey)
      sessionStorage.nav_key = obj.key
      this.navKey = [obj.key]
    },
    fetch () {
      axios.post(this.getUserUrlPermissionUrl, {
        token: sessionStorage.token
      })
        .then((data) => {
          if (data.data.err_code === 0) {
            console.log(data.data.content.user_permission_list)
            let permissionList = data.data.content.user_permission_list
            // permissionList.push('RaiseAccount')
            this.navList = [{
              key: '1',
              name: '群列表',
              iconType: 'usergroup-add',
              value: '/ChatroomManage'
            }, {
              key: '2',
              name: '客户列表',
              iconType: 'user',
              value: '/ClientManage'
            },
              // {
              //   key: '3',
              //   name: '群主列表',
              //   iconType: 'wechat',
              //   value: 'ownerList'
              // }
            {
              key: '4',
              name: '设备管理',
              iconType: 'mobile',
              value: '/DeviceManage'
            },
            {
              key: '5',
              name: '机器人管理',
              iconType: 'android',
              value: '/BotManage'
            },
            {
              key: '6',
              name: '用户交易记录',
              iconType: 'pay-circle',
              value: '/BalanceManage'
            },
            {
              key: '7',
              name: '后台操作记录',
              iconType: 'profile',
              value: '/LogManage'
            },
            // {
            //   key: '8',
            //   name: '数据概览',
            //   iconType: 'database',
            //   value: '/GeneralManage'
            // },
            {
              key: '9',
              name: '用户管理',
              iconType: 'setting',
              value: '/UserManage'
            },
            {
              key: '11',
              name: '大客户管理',
              iconType: 'trophy',
              value: '/BizManage'
            },
            {
              key: '12',
              name: '文件素材管理',
              iconType: 'picture',
              value: '/MaterialManage'
            },
            {
              key: '13',
              name: '供应商管理',
              iconType: 'car',
              value: '/ProviderManage'
            },
            {
              key: '14',
              name: '我的用户',
              iconType: 'user',
              value: '/MyClient'
            },
            {
              key: '15',
              name: '养号管理',
              iconType: 'solution',
              value: '/RaiseAccount'
            }
            ].filter(item => permissionList.indexOf(item.value.substring(1)) !== -1)
            if (this.navList.length > 0) {
              this.navKey = [this.navList[0].key]
              this.$router.push(this.navList[0].value)
            }
          } else if (data.data.err_code === 50002) {
            console.log('token 不对，跳转登录')
            this.$router.push('/')
          }
        })
    }
  }
}

</script>

<style>
  #main-layout .logo {
    height: 32px;
    background: rgba(255,255,255,.2);
    margin: 16px;
  }
</style>
